
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import ClasshourLiveStatus from './LiveStatus.vue'
import type { ClasshourDetail as TClasshourDetail } from '@xt/client/entities/course-v2/types.d'

@Observer
@Component({
  components: {
    ClasshourLiveStatus
  }
})
export default class ClasshourLive extends Vue {
  @Prop() data: TClasshourDetail['classhourInfo']
}
